import styled, { keyframes } from 'styled-components'

const blink = keyframes`
0% {
    opacity: 1;
}
50% {
    opacity: 0; 
}
100% {
    opacity: 1; 
}`

const enterLeft = keyframes`
from {
    opacity: 0;
    transform: translateX(-2%);
}
to {
    opacity: 1;
    transform: translateX(0%);
}`

const enterRight = keyframes`
from {
    opacity: 0;
    transform: translateX(2%);
}
to {
    opacity: 1;
    transform: translateX(0%);
}`

const enterUpLeft = keyframes`
from {
    opacity: 0;
    transform: translateY(100%);
    visibility: hidden;
}
to {
    opacity: 1;
    transform: translateY(0%);
    visibility: visible;
}`

const enterUpRight = keyframes`
from {
    opacity: 0;
    transform: translateY(-100%);
    visibility: hidden;
}
to {
    opacity: 1;
    transform: translateY(0%);
    visibility: visible;
}`

const progressWidth = keyframes`
from {
    width: 0;
}
to {
    width: 100%;
}`

export {
  blink,
  enterLeft,
  enterRight,
  enterUpLeft,
  enterUpRight,
  progressWidth
}



// WEBPACK FOOTER //
// ./src/components/slider/animations.js